module.exports = __webpack_public_path__ + "img/f8d659c.svg";